import React from 'react';
import PropTypes from 'prop-types';
import Text from './Text';

function Copy(props) {
  return <Text className={props.className} text={[`© ${props.text}`]} />;
}

Copy.defaultProps = {
  text: null
};

Copy.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

export default Copy;



// WEBPACK FOOTER //
// ./src/components/ui/Copy.jsx